import { CardContent, GridLegacy, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { gridSpacing } from 'constants/themeConstants';
import MainCard from 'ui-component/cards/MainCard';

type FormSectionProps = {
  title?: string | ReactNode;
  children: ReactNode;
};

const FormSection: FC<FormSectionProps> = ({ title, children }) => (
  <MainCard content={false} sx={{ mb: 2 }}>
    <CardContent>
      <GridLegacy container spacing={gridSpacing}>
        {title && (
          <GridLegacy item xs={12}>
            <Typography variant="h4">{title}</Typography>
          </GridLegacy>
        )}
        <GridLegacy item xs>
          {children}
        </GridLegacy>
      </GridLegacy>
    </CardContent>
  </MainCard>
);

export default FormSection;
